import axiosInstance from 'utils/axiosInstance';
import {
  DocumentDemandInfo,
  DocumentRecord,
  ExtractHtmlFromTemplateResponse,
  ResponseDemandDocument,
  StatisticsDocument,
} from '../types/document';

export const GetStatisticDocument = async (): Promise<StatisticsDocument> => {
  const { data } = await axiosInstance.get<ApiResponse<StatisticsDocument>>(
    '/api/demanddocument/statistic',
  );
  return data.data;
};

export const GetStatisticDocumentProfile = async (
  userId: string,
): Promise<StatisticsDocument> => {
  const { data } = await axiosInstance.get<ApiResponse<StatisticsDocument>>(
    `/api/demanddocument/statistic/${userId}`,
  );
  return data.data;
};

export const GetCreateDocument = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<ResponseDemandDocument>>(
    `api/demanddocument/demand/${id}`,
  );
  return data.data;
};

export const CreateDemondeDocument = async (credentials: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/demanddocument/update',
    credentials,
  );
  return data;
};

export const GetInfoDemandeDocument = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<DocumentDemandInfo>>(
    `api/demanddocument/info/${id}`,
  );
  return data.data;
};

export const DeleteDocumentService = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<null>>(
    `api/demanddocument/delete/${id}`,
  );
  return data;
};

export const documentTypesService = async () => {
  const { data } = await axiosInstance.get<ApiResponse<SelectItem[]>>(
    'api/documenttype/list',
  );
  return data;
};

export const ProcessedDemandeDocument = async (credentails: FormData) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/demanddocument/processed',
    credentails,
  );
  return data;
};

export const GetDemandeDocumentListing = async (
  requestFilters: TableResponse<DocumentRecord[]>,
): Promise<TableResponse<DocumentRecord[]>> => {
  const { data } = await axiosInstance.post(
    'api/demanddocument/listing',
    requestFilters,
  );
  return data.data;
};

export const ExtractHtmlFromTemplateService = async (
  id: number,
  TypeId: number,
  headers = true,
): Promise<ApiResponse<ExtractHtmlFromTemplateResponse>> => {
  const { data } = await axiosInstance.get(
    `api/demanddocument/ExtractHtmlFromTemplate/${id}/${TypeId}/${headers}`,
  );
  return data;
};

export const updateTextTemplateService = async (content: {
  id: number;
  text: string;
}): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post(
    'api/demanddocument/updateText',
    content,
  );
  return data;
};

export const documentsTypelist = async (): Promise<SelectItem[]> => {
  const { data } = await axiosInstance.get('/api/demanddocument/Typelist');
  return data;
};
